import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Coffee } from '../Icons.js';
import Header from '../header/Header';
import { cards } from './config.js';
import performFlipAnimation from '../animation';
import './Cards.css';

export default class Cards extends Component {
    constructor(props) {
        super(props);
        this.cards = [];
        this.selectedClass = 'card--selected';
        this.animationClass = 'card--animatable';
    }

    componentDidUpdate(prevProps) {
        const prevCard = this.props.match.params.selectedCard;
        const newCard = prevProps.match.params.selectedCard;
        // only if we switch from card detail to overview or vice versa:
        if (!!prevCard !== !!newCard) {
                // get the card that will be shown or dismissed
                const card = prevCard || newCard;
                const cardEl = this.cards ? this.cards[card] : null;
                if (cardEl) {
                    // animate to its new state
                    cardEl.classList.toggle(this.selectedClass);
                    performFlipAnimation(cardEl, this.selectedClass, this.animationClass);
                }
        }
    }

	render() {
        const { selectedCard } = this.props.match.params;
		return (
            <div>
                <Header page="nav_cards" hidden={selectedCard !== undefined} />
                <div class={`cards ${selectedCard ? 'cards--detail-view' : ''}`}>
                { cards.map( card => (
                    <Link
                        className={`card card--${card.route} ${selectedCard && selectedCard === card.route ? this.selectedClass : ''}`}
                        to={`/cards/${card.route}`}
                        ref={domCard => {
                            if (!domCard) {
                                return;
                            }
                            this.cards[card.route] = domCard.base;
                        }}
                    >
                        <div className="card__label">
                            {card.route === 'coffee' ? <Coffee /> : card.label}
                        </div>
                    </Link>
                )) }
                </div>
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/cards/Cards.js